import styled from '@emotion/styled';
import { useState } from 'react';
import { useOfferList } from './useOfferList';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { AboutService } from 'ui/components/company/features/AboutService';
import { UserTypeTab, TabType } from 'ui/components/agent/features/Tab/UserTypeTab';
import { mqUser } from 'utils/responsive';
import { PublicCompanyCard } from 'ui/components/agent/features/Card/PublicCompanyCard';
import { PublicBuyerCardHorizontally } from 'ui/components/agent/features/Card/PublicBuyerCardHorizontally';

const descriptions: { [key: string]: string[] } = {
    メッセージのやり取り: [
        'オファーを送信した企業の一覧です。お相手がオファーを承諾した場合、メッセージのやり取りが可能です。',
    ],
};

const Wrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const MatchListContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 0;
    margin-top: 20px;
`;

export const OfferList: React.FC = () => {
    const { loading, offerCompanies, offerBuyers } = useOfferList();
    const [activeTab, setActiveTab] = useState<TabType>('all');

    const filteredOfferList = {
        companies: offerCompanies.filter(() => {
            switch (activeTab) {
                case 'seller':
                    return true;
                case 'buyer':
                    return false;
                case 'all':
                default:
                    return true;
            }
        }),
        buyers: offerBuyers.filter(() => {
            switch (activeTab) {
                case 'seller':
                    return false;
                case 'buyer':
                    return true;
                case 'all':
                default:
                    return true;
            }
        }),
    };

    return (
        <Wrapper>
            <PageTitle title="オファー中の企業一覧" />
            <AboutService descriptions={descriptions} />
            <UserTypeTab activeTab={activeTab} onTabChange={setActiveTab} />
            <MatchListContainer>
                {!loading && (
                    <>
                        {filteredOfferList.companies.map((company) => (
                            <PublicCompanyCard
                                key={`company-${company.id}`}
                                company={company}
                                showCompanyTypeLabel
                                onClick={() => window.open(`/agent/companies/${company.id}/`, '_blank')}
                            />
                        ))}
                        {filteredOfferList.buyers.map((buyer) => (
                            <PublicBuyerCardHorizontally
                                key={`buyer-${buyer.id}`}
                                buyer={buyer}
                                showCompanyTypeLabel
                                onClick={() => window.open(`/agent/buyers/${buyer.id}/`, '_blank')}
                            />
                        ))}
                    </>
                )}
            </MatchListContainer>
        </Wrapper>
    );
};
